import { useParams } from 'react-router-dom';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader/PageHeader';
import DiscountTable from './DiscountTable';

const DiscountPage = () => {

  const { locationId } = useParams();
  const { t } = useTranslation();

  return (
    <Box p={3}>
      <PageHeader title={t('discounts')} subtitle={t('manage_discount')} />
      <Box mt={2}>
        <DiscountTable locationId={locationId} />
      </Box>
    </Box>
  );
};

export default DiscountPage;
